// src/components/PageTransition.tsx
import * as React from "react";
import { AnimatePresence, motion } from "framer-motion";

const variants = {
  // start a little down, transparent and slightly smaller
  initial: { opacity: 0 },
  // animate to full size, visible and centered
  in: { opacity: 1 },
  // exit by fading out, shrinking and moving up
  out: { opacity: 0 },
};

export default function PageTransition({ element, location }) {
  // ensure the body itself uses a dark background to avoid white flash
  React.useEffect(() => {
    const prev = document.body.style.backgroundColor;
    document.body.style.backgroundColor = "#111"; // dark gray
    return () => {
      document.body.style.backgroundColor = prev;
    };
  }, []);

  return (
    <AnimatePresence mode="wait">
      <motion.main
        key={location.pathname}
        className="min-h-screen bg-zinc-950 dark:bg-zinc-900"
        variants={variants}
        initial="initial"
        animate="in"
        exit="out"
        transition={{
          type: "spring",
          damping: 20,
          stiffness: 120,
          duration: 0.4,
        }}
      >
        {element}
      </motion.main>
    </AnimatePresence>
  );
}
